/**
 * Normalize a string element for comparison: strip diacritics, whitespace, and lowercase.
 *
 * @param str - Input string (may be null/undefined)
 * @returns Normalized string, or undefined if input is nullish
 */
export const normalizeStringElement = (str: string | null | undefined): string | undefined => (
    str
        ?.normalize?.('NFD')
        ?.replace?.(/[̀-ͯ]/g, '')
        ?.replace?.(/\s/g, '')
        ?.toLocaleLowerCase?.()
)

/**
 * Check if string contains substring (diacritic- and whitespace-insensitive).
 *
 * @param string - The string to search within
 * @param substring - The substring to search for
 * @returns true if the normalized string contains the normalized substring
 */
export const stringContainsSubstring = (
    string: string | null | undefined,
    substring: string | null | undefined,
): boolean => {
    const normalizedString = normalizeStringElement(string)
    const normalizedSubstring = normalizeStringElement(substring)

    return Boolean(normalizedString?.includes?.(normalizedSubstring ?? ''))
}
